import React from "react";
import { Check, TriangleAlert } from "lucide-react";
import { MANDATORY_LABELS, getMissingMandatoryFields } from "@/lib/mandatoryFields";

/** Badge "Provision bereit ✓" / "Daten unvollständig ⚠️" für Policen- und Anträge-Listen.
 *  Zeigt auf einen Blick, ob alle provisionsrelevanten Pflichtfelder vorhanden sind.
 */
export default function ProvisionReadyBadge({ insuranceType, premium, details, testId }) {
  const missing = getMissingMandatoryFields({ insurance_type: insuranceType, premium, details });
  if (missing.length === 0) {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-widest bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400"
        title="Alle provisionsrelevanten Felder vorhanden — Provision kann berechnet werden"
        data-testid={testId ? `provision-ready-${testId}` : undefined}
      >
        <Check className="w-3 h-3" strokeWidth={2.5} /> Provision bereit
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-widest bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-300"
      title={`Fehlend: ${missing.map((k) => MANDATORY_LABELS[k]).join(", ")} — bitte Police bearbeiten und ergänzen`}
      data-testid={testId ? `provision-incomplete-${testId}` : undefined}
    >
      <TriangleAlert className="w-3 h-3" strokeWidth={2.5} /> Daten unvollständig
    </span>
  );
}
